// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import WarningTwoToneSvg from "@fishx/icons-svg/es/asn/WarningTwoTone";
import FishxIcon from '../components/FishxIcon';

var WarningTwoTone = function WarningTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: WarningTwoToneSvg
  }));
};

WarningTwoTone.displayName = 'WarningTwoTone';
export default React.forwardRef(WarningTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/WarningTwoTone.js
// module id = 4392
// module chunks = 0